import { MenuItemType } from "@arelia-components/ui-atoms/menu-selector/models";
import SortIcon from '@mui/icons-material/Sort';
import { SortOrder } from "@arelia-types/data-models";
import { RoyaltiesEarningsSorting, SortOrderMap as SortOrderMapType, SortValueGetterMap as SortValueGetterMapType } from "./models";
import SortMenuLabel from "@arelia-components/ui-atoms/SortMenuLabel";

export const sortByMenu: MenuItemType<RoyaltiesEarningsSorting>[] = [{
  label: <SortMenuLabel><SortIcon />Most Earned first</SortMenuLabel >,
  value: RoyaltiesEarningsSorting.amountEarnedDesc
}, {
  label: <SortMenuLabel><SortIcon sx={{ transform: "scaleY(-1)" }} />Less Earned first</SortMenuLabel>,
  value: RoyaltiesEarningsSorting.amountEarnedAsc
}];

export const SortOrderMap: SortOrderMapType = {
  [RoyaltiesEarningsSorting.amountEarnedAsc]: SortOrder.asc,
  [RoyaltiesEarningsSorting.amountEarnedDesc]: SortOrder.desc,
};

export const SortValueGetterMap: SortValueGetterMapType = {
  [RoyaltiesEarningsSorting.amountEarnedAsc]: earning => earning.amountEarned,
  [RoyaltiesEarningsSorting.amountEarnedDesc]: earning => earning.amountEarned,
};